import PropTypes from 'prop-types';

const sharedPropTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    formatValue: PropTypes.func,
    parseValue: PropTypes.func,
    formatDisplayText: PropTypes.func,
    callbackArguments: PropTypes.object,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    onSave: PropTypes.func,
    onChange: PropTypes.func,
    onEditMode: PropTypes.func,
    onBlur: PropTypes.func,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    readonly: PropTypes.bool,
    inputClassName: PropTypes.string
};

export const EditTextPropTypes = {
    ...sharedPropTypes,
    type: PropTypes.string,
    inline: PropTypes.bool,
    showEditButton: PropTypes.bool,
    editButtonContent: PropTypes.any,
    editButtonProps: PropTypes.object
};

export const EditTextareaPropTypes = {
    ...sharedPropTypes,
    rows: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])])
};